import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import { Box, LinearProgress, SelectChangeEvent } from '@mui/material'
import styled from '@emotion/styled'
import SingleSelect from '../../../../components/muiComponents/singleSelect'
import { Body1, H3 } from '../../../../layouts/TextStyles'
import { homeworkApiSlice } from '../../../../features/section/homeworkSlice'
import TopicHomeworkCard from '../components/TopicHomeworkCard'

interface Props {
    subjectId: number | null
    userCourseEnrollId: number
    loadingSubjects?: boolean
}

const HomeworkTab: React.FC<Props> = ({
    subjectId,
    loadingSubjects = false,
    userCourseEnrollId
}) => {
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const [courseSubject, setCourseSubject] = useState(Number(searchParams.get('courseSubjectId')) || null)
    const { data: homework = [], isFetching, refetch } =
        homeworkApiSlice.useGetStudentTopicHomeworkAnalysisQuery(
            { courseSubjectId: courseSubject, userCourseEnrollId: userCourseEnrollId },
            { skip: !courseSubject },
        )

    useEffect(() => {
        if (subjectId) {
            setCourseSubject(subjectId)
        }
    }, [subjectId])

    return (
        <Box>
            {isFetching ? (
                <LinearProgress />
            ) : (
                homework.length > 0 ? homework.map((homework) => (
                    <TopicHomeworkCard
                        key={homework.id}
                        homework={homework}
                        refetch={refetch}
                    />
                )) :
                    <Body1 color="#434343" style={{ textAlign: 'center' }}>{formatMessage({ id: 'noHomework' })}</Body1>
            )}



        </Box>
    )
}

export default HomeworkTab
